/* ==========================================================================
   Craftly — product page: variants, gallery, zoom, sticky ATC
   ========================================================================== */
(function () {
  'use strict';

  var strings = (window.Theme && window.Theme.strings) || {};

  function money(cents) {
    return window.formatMoney ? window.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  /* ---------- Media gallery ---------- */

  function initGallery(root) {
    var gallery = root.querySelector('[data-product-gallery]');
    if (!gallery || gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-media-id]'));

    function show(mediaId) {
      items.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === String(mediaId));
      });
      thumbs.forEach(function (thumb) {
        thumb.setAttribute(
          'aria-current',
          thumb.getAttribute('data-thumb-media-id') === String(mediaId) ? 'true' : 'false'
        );
      });
    }

    gallery._show = show;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(thumb.getAttribute('data-thumb-media-id'));
      });
    });

    // Zoom lightbox
    gallery.addEventListener('click', function (event) {
      var img = event.target.closest('.product__media-item.is-active img');
      if (!img) return;

      var box = document.createElement('div');
      box.className = 'zoom-lightbox';
      box.innerHTML =
        '<button type="button" class="zoom-lightbox__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button><img src="' + (img.getAttribute('data-zoom-src') || img.src) + '" alt="">';

      document.body.appendChild(box);
      document.body.style.overflow = 'hidden';

      var close = function () {
        box.remove();
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey);
      };
      var onKey = function (e) {
        if (e.key === 'Escape') close();
      };

      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('.zoom-lightbox__close')) close();
      });
      document.addEventListener('keydown', onKey);
    });
  }

  /* ---------- Variant picker ---------- */

  function initVariants(root) {
    var picker = root.querySelector('[data-variant-picker]');
    var dataEl = root.querySelector('[data-product-json]');
    if (!picker || !dataEl || picker.dataset.variantReady === 'true') return;
    picker.dataset.variantReady = 'true';

    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = product.variants || [];
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[data-variant-id]');
    var submitButton = form && form.querySelector('[type="submit"]');
    var priceWrap = root.querySelector('[data-product-price]');
    var skuEl = root.querySelector('[data-product-sku]');
    var inventoryEl = root.querySelector('[data-product-inventory]');
    var gallery = root.querySelector('[data-product-gallery]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function selectedOptions() {
      return Array.prototype.slice
        .call(picker.querySelectorAll('input[type="radio"]:checked, select[data-option-select]'))
        .map(function (el) { return el.value; });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function updateAvailability(options) {
      // Grey out combinations that don't exist
      picker.querySelectorAll('[data-option-position]').forEach(function (group) {
        var position = parseInt(group.getAttribute('data-option-position'), 10) - 1;
        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var test = options.slice();
          test[position] = input.value;
          var match = variants.find(function (variant) {
            return variant.options.every(function (option, index) {
              return index === position ? option === input.value : option === test[index];
            });
          });
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function renderPrice(variant) {
      if (!priceWrap) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html =
          '<span class="price__sale">' + money(variant.price) + '</span>' +
          '<s class="price__compare">' + money(variant.compare_at_price) + '</s>';
      } else {
        html = '<span>' + money(variant.price) + '</span>';
      }
      priceWrap.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
    }

    function renderInventory(variant) {
      if (!inventoryEl) return;
      inventoryEl.className = 'product__inventory';
      if (!variant.available) {
        inventoryEl.classList.add('product__inventory--out');
        inventoryEl.textContent = inventoryEl.getAttribute('data-out-text') || 'Out of stock';
        return;
      }
      var qty = variant.inventory_quantity;
      var policy = variant.inventory_management;
      if (policy && typeof qty === 'number' && qty > 0 && qty <= 10) {
        inventoryEl.classList.add('product__inventory--low');
        inventoryEl.textContent = (inventoryEl.getAttribute('data-low-text') || 'Only [count] left!').replace('[count]', qty);
      } else {
        inventoryEl.classList.add('product__inventory--in');
        inventoryEl.textContent = inventoryEl.getAttribute('data-in-text') || 'In stock';
      }
    }

    function update() {
      var options = selectedOptions();
      updateAvailability(options);

      var variant = findVariant(options);

      if (!variant) {
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available
          ? strings.addToCart || 'Add to cart'
          : strings.soldOut || 'Sold out';
      }

      renderPrice(variant);
      renderInventory(variant);

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (variant.featured_media && gallery && gallery._show) {
        gallery._show(variant.featured_media.id);
      }

      if (history.replaceState && product.url) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    picker.addEventListener('change', update);
    update();
  }

  /* ---------- Sticky add to cart ---------- */

  function initStickyAtc(root) {
    var sticky = document.querySelector('[data-sticky-atc]');
    var anchor = root.querySelector('[data-product-form]');
    if (!sticky || !anchor || sticky.dataset.stickyReady === 'true') return;
    sticky.dataset.stickyReady = 'true';

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    var stickyButton = sticky.querySelector('[data-sticky-add]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        anchor.requestSubmit ? anchor.requestSubmit() : anchor.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ---------- Init ---------- */

  function init() {
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      initGallery(root);
      initVariants(root);
      initStickyAtc(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
